import { api } from './api';

const dataManagementService = {
    // Export data
    exportData: async (collections = null) => {
        try {
            // First get the JSON data
            const response = await api.post('/data-management/export', { collections });
            
            // Convert JSON to blob
            const jsonString = JSON.stringify(response, null, 2);
            const blob = new Blob([jsonString], { type: 'application/json' });
            
            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            
            // Generate filename
            const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
            const filename = `aghrba-export-${timestamp}.json`;
            
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            
            return { success: true, message: 'Data exported successfully' };
        } catch (error) {
            console.error('Export failed:', error);
            throw error;
        }
    },
    
    // Import data
    importData: async (file, options = {}) => {
        try {
            const text = await file.text();
            const data = JSON.parse(text);
            
            const response = await api.post('/data-management/import', {
                data,
                options
            });
            
            return response;
        } catch (error) {
            console.error('Import failed:', error);
            throw error;
        }
    },
    
    // Create backup
    createBackup: async (description = '') => {
        try {
            const response = await api.post('/data-management/backup', { description });
            return response;
        } catch (error) {
            console.error('Backup creation failed:', error);
            throw error;
        }
    },
    
    // List backups
    listBackups: async (page = 1, limit = 10) => {
        try {
            const response = await api.get(`/data-management/backup?page=${page}&limit=${limit}`);
            return response;
        } catch (error) {
            console.error('Failed to list backups:', error);
            throw error;
        }
    },
    
    // Restore backup
    restoreBackup: async (backupId, options = {}) => {
        try {
            const response = await api.post(`/data-management/backup/${backupId}/restore`, { options });
            return response;
        } catch (error) {
            console.error('Restore failed:', error);
            throw error;
        }
    },
    
    // Delete backup
    deleteBackup: async (backupId) => {
        try {
            const response = await api.delete(`/data-management/backup/${backupId}`);
            return response;
        } catch (error) {
            console.error('Delete backup failed:', error);
            throw error;
        }
    },
    
    // Get operation progress
    getProgress: async (operationId) => {
        try {
            const response = await api.get(`/data-management/progress/${operationId}`);
            return response;
        } catch (error) {
            console.error('Failed to get progress:', error);
            throw error;
        }
    },
    
    // Get backup configuration
    getBackupConfig: async () => {
        try {
            const response = await api.get('/backup-config');
            return response;
        } catch (error) {
            console.error('Failed to get backup config:', error);
            throw error;
        }
    },
    
    // Update backup configuration
    updateBackupConfig: async (config) => {
        try {
            const response = await api.put('/backup-config', config);
            return response;
        } catch (error) {
            console.error('Failed to update backup config:', error);
            throw error;
        }
    },
    
    // Test backup configuration
    testBackupConfig: async () => {
        try {
            const response = await api.post('/backup-config/test');
            return response;
        } catch (error) {
            console.error('Failed to test backup config:', error);
            throw error;
        }
    },
    
    // Get backup schedule status
    getScheduleStatus: async () => {
        try {
            const response = await api.get('/backup-config/status');
            return response;
        } catch (error) {
            console.error('Failed to get schedule status:', error);
            throw error;
        }
    },
    
    // Trigger manual backup
    triggerManualBackup: async () => {
        try {
            const response = await api.post('/backup-config/trigger');
            return response;
        } catch (error) {
            console.error('Failed to trigger manual backup:', error);
            throw error;
        }
    }
};

export default dataManagementService;